/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyIAPReceiptRequest
 */
export interface VerifyIAPReceiptRequest {
    /**
     * ID of the order to complete
     * @type {string}
     * @memberof VerifyIAPReceiptRequest
     */
    orderId: string;
    /**
     * Base64 encoded Apple receipt
     * @type {string}
     * @memberof VerifyIAPReceiptRequest
     */
    receipt: string;
    /**
     * Apple product ID that was purchased
     * @type {string}
     * @memberof VerifyIAPReceiptRequest
     */
    productId: string;
    /**
     * Apple transaction ID
     * @type {string}
     * @memberof VerifyIAPReceiptRequest
     */
    transactionId: string;
    /**
     * Apple original transaction ID
     * @type {string}
     * @memberof VerifyIAPReceiptRequest
     */
    originalTransactionId?: string;
}

/**
 * Check if a given object implements the VerifyIAPReceiptRequest interface.
 */
export function instanceOfVerifyIAPReceiptRequest(value: object): value is VerifyIAPReceiptRequest {
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('receipt' in value) || value['receipt'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    return true;
}

export function VerifyIAPReceiptRequestFromJSON(json: any): VerifyIAPReceiptRequest {
    return VerifyIAPReceiptRequestFromJSONTyped(json, false);
}

export function VerifyIAPReceiptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyIAPReceiptRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'],
        'receipt': json['receipt'],
        'productId': json['productId'],
        'transactionId': json['transactionId'],
        'originalTransactionId': json['originalTransactionId'] == null ? undefined : json['originalTransactionId'],
    };
}

  export function VerifyIAPReceiptRequestToJSON(json: any): VerifyIAPReceiptRequest {
      return VerifyIAPReceiptRequestToJSONTyped(json, false);
  }

  export function VerifyIAPReceiptRequestToJSONTyped(value?: VerifyIAPReceiptRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'receipt': value['receipt'],
        'productId': value['productId'],
        'transactionId': value['transactionId'],
        'originalTransactionId': value['originalTransactionId'],
    };
}

